
  <div class="grid-container" *ngIf="pageContent && reportGroup"
  [ngStyle]="{'grid-template-columns': reportGroup.FullWidth ? reportGroup.FullWidth : gridColumns, 'grid-template-rows': reportGroup.FullHeight ? reportGroup.FullHeight : gridRows, '-ms-grid-columns': msGridColumns, '-ms-grid-rows': msGridRows}">

    <ng-container *ngFor="let report of reportGroup.EPICs;">
      <div [ngClass]="{'grid-item custom-scrollbar': true}"
      [ngStyle]="{'grid-column': 'span '+ report.Width, 'grid-row': report.StartRow + ' / span ' + report.Height, 'padding': report.MarginValue ? report.MarginValue : '0px',
      '-ms-grid-column': report.StartColumn, '-ms-grid-column-span': report.Width, '-ms-grid-row': report.StartRow, '-ms-grid-row-span': report.Height}">
        <app-reportcard [setReport]="report" (variableChanged)="UpdateVariable($event)" [updateVariable]="variables" [reportGroupWidth]="reportGroup.Width" [groupName]="reportGroup.GroupName" 
        [pageContent]="pageContent" (getRelatedEpic)="getRelatedEpic($event)" (hidePanel)="togglePanel($event, report)" [isFixHeight]="isFixHeight"  [dialog]="dialog"></app-reportcard>
      </div>
    </ng-container>

    <!-- <div class="row"> -->
        <!-- padding should go down here, which means margin in apm   -->
      <!-- <div class="col-md-12 col-sm-12" *ngFor="let report of reportGroup.EPICs;">
        <app-reportcard [setReport]="report" (variableChanged)="UpdateVariable($event)" 
        [updateVariable]="variables" [reportGroupWidth]="reportGroup.Width" [groupName]="reportGroup.GroupName" 
        [pageContent]="pageContent" (getRelatedEpic)="getRelatedEpic($event)" 
        (hidePanel)="togglePanel($event, report)" [isFixHeight]="isFixHeight"  [dialog]="dialog"></app-reportcard>
      </div>
    </div> -->
  </div>

  


  <!-- 'grid-auto-rows': 'calc(((100vw * (' + reportGroup.Width + ' / '  + pageContent.PageWidth + ')) - (15px * ('+ reportGroup.Width +' -1))) / ' + reportGroup.Width + ')'}" -->